export default {
  show_restrictions_modal_title: "Restrictions",
  show_restrictions_modal_close: "Close",
  show_restrictions_current_config_not_allowed: "The current configuration is not allowed",
  show_restrictions_current_config_is_allowed: "The current configuration is allowed",
  show_restrictions_aux_camera: "AUX",
  show_restrictions_model: "Model",
  show_restrictions_model2: "Model 2",
  show_restrictions_pc_control: "Privacy Control",
  show_restrictions_video_resolution: "Video",
};







